<template>
    <div>
        <h5 class="mt-4 mb-3">Post fields</h5>
        <div v-for="(field, i) in fields" :key="field.id" class="row mb-3" style="display: flex;">
            <div class="col-sm-4">
                <select :name="getFieldName(i, 'name')"
                        :id="getFieldId(i, 'name')"
                        v-model="field.name"
                        class="form-select">
                    <option v-for="(name, val) in allowedFields" :value="val">{{ name }}</option>
                </select>
            </div>
            <div class="col-sm-4">
                <input type="text"
                       :name="getFieldName(i, 'value')"
                       :id="getFieldId(i, 'value')"
                       v-model="field.value"
                       class="form-control"
                       placeholder="Value" />
            </div>
            <div class="col-sm-4">
                <button class="btn btn-danger" @click.prevent.stop="removeField(field)">Remove</button>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <button class="btn btn-primary" @click.prevent.stop="addField()">Add field</button>
            </div>
        </div>
    </div>
</template>

<script>
let id = 1;

export default {
    props: {
        fieldData: Array,
        allowedFields: Array,
    },
    data() {
        return {
            fields: this.fieldData,
        };
    },
    created() {
        this.fields.forEach(field => field.id = id++);
    },
    methods: {
        getFieldName(index, key) {
            return `fields[${index}][${key}]`;
        },
        getFieldId(index, key) {
            return `fields_${index}_${key}`;
        },
        addField() {
            this.fields.push({
                id: id++,
                name: '',
                value: '',
            });
        },
        removeField(field) {
            for (let i = 0; i < this.fields.length; i++) {
                if (this.fields[i].id === field.id) {
                    this.fields.splice(i, 1);
                    break;
                }
            }
        }
    }
}
</script>